import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const signals = [
    {
      icon: 'Shield',
      title: 'SSL Encrypted',
      description: '256-bit encryption'
    },
    {
      icon: 'Lock',
      title: 'Google OAuth',
      description: 'Secure authentication'
    },
    {
      icon: 'CheckCircle',
      title: 'AWS Compliant',
      description: 'Industry standards'
    }
  ];

  return (
    <div className="mt-8 pt-8 border-t border-border">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {signals?.map((signal, index) => (
          <div key={index} className="flex flex-col items-center text-center">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-3">
              <Icon name={signal?.icon} size={20} color="var(--color-primary)" />
            </div>
            <h3 className="text-sm font-semibold text-foreground mb-1">
              {signal?.title}
            </h3>
            <p className="text-xs text-muted-foreground">
              {signal?.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustSignals;